import React from "react";
import PropTypes from "prop-types";
import UIButton from "../UIButton";

const UIActionModalActions = ({
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  confirmDisabled,
  confirmLoading,
  confirmVariant,
}) => (
  <div className="ui-modal__actions ui-action-modal__actions">
    <UIButton variant="outline" size="medium" fullWidth onClick={onCancel}>
      {cancelLabel}
    </UIButton>
    <UIButton
      appearance={confirmVariant === "approve" ? "gradient" : "default"}
      color={confirmVariant === "reject" ? "error" : "primary"}
      size="medium"
      fullWidth
      disabled={confirmDisabled}
      loading={confirmLoading}
      onClick={onConfirm}
    >
      {confirmLabel}
    </UIButton>
  </div>
);

export default UIActionModalActions;

UIActionModalActions.propTypes = {
  cancelLabel: PropTypes.node.isRequired,
  confirmLabel: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmDisabled: PropTypes.bool,
  /** The confirmed action is being sent: the button shows its spinner and can't be pressed. */
  confirmLoading: PropTypes.bool,
  confirmVariant: PropTypes.oneOf(["approve", "reject"]),
};

UIActionModalActions.defaultProps = {
  confirmDisabled: false,
  confirmLoading: false,
  confirmVariant: "approve",
};